import { SidebarMenu } from '../../../enum/SidebarMenu';

import icon from '../../../assets/img/svg/sidebar/statistics.svg';

export const statistics = {
  sidebarMenuType: SidebarMenu.STATISTICS,
  label: 'sidebar.statistics.title',
  path: '/',
  routes: undefined,
  icon: icon,
  headerConfig: {
    search: true,
    datePicker: true,
    sumBy: true,
    columnOrder: true,
    exportToExcel: true,
    exportToPDF: true,
    updateData: true,
  },
  footerConfig: { visibleItemsCount: true },
  testId: 'statistics',
};
